export function flatten (str: string) {
  return str
}
